import createApiClient from "./api";

const api = createApiClient();

export const fetchVendors = async (
  projectId,
  page = 1,
  pageSize = 1000,
  filters = {},
  sortField = null,
  sortOrder = null
) => {
  const token = localStorage.getItem("token");
  const params = {
    skip: (page - 1) * pageSize,
    limit: pageSize,
  };
  if (filters && Object.keys(filters).length > 0) {
    params.filters = JSON.stringify(filters);
  }
  if (sortField && sortOrder) {
    params.sort_field = sortField;
    params.sort_order = sortOrder;
  }
  const response = await api.get(`/projects/${projectId}/vendors`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const { data, total } = response.data;
  return { vendors: data, total };
};

export const createVendor = async (vendorData) => {
  const token = localStorage.getItem("token");
  const response = await api.post("/vendors", vendorData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const updateVendor = async (vendorId, vendorData) => {
  const token = localStorage.getItem("token");
  const response = await api.put(`/vendors/${vendorId}`, vendorData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const deleteVendor = async (vendorId) => {
  const token = localStorage.getItem("token");
  const response = await api.delete(`/vendors/${vendorId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};


export const fetchVendor = async (vendorId) => {
  const token = localStorage.getItem("token");
  const response = await api.get(`/vendors/${vendorId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};